import { LOGIN, LOGOUT, SIGN_UP, RESET, ACTIVATION } from "app/auth/constants";
import { Intent } from "@blueprintjs/core";
import { AppToaster } from "app/toaster";
import { messages } from "app/utils";

let locale_messages;

const getToast = ({ locale_messages, type }) => {
  const toasts = {
    [LOGIN.SUCCESS]: {
      iconName: "tick",
      message: auth => {
        return `${locale_messages["auth.loggedin.success"]} ${auth.user.name}`;
      },
      intent: Intent.SUCCESS
    },
    [LOGOUT]: {
      iconName: "tick",
      message: locale_messages["auth.loggedout.success"],
      intent: Intent.SUCCESS
    },
    [SIGN_UP.SUCCESS]: {
      iconName: "tick",
      message: locale_messages["auth.signedup.success"],
      intent: Intent.SUCCESS
    },
    [RESET.SUCCESS]: {
      iconName: "tick",
      message: locale_messages["auth.reset.initiated"],
      intent: Intent.SUCCESS
    },
    [ACTIVATION.SUCCESS]: {
      iconName: "tick",
      message: locale_messages["auth.account.activate"],
      intent: Intent.SUCCESS
    }
  };

  return toasts[type];
};

const showToast = toast => data => {
  if (!toast) return;
  if (typeof toast.message === "function") {
    toast.message = toast.message(data);
  }
  AppToaster.show(toast);
};

const handleAction = ({ state, action, locale_messages }) => {
  if (action.type)
    showToast(getToast({ locale_messages, type: action.type }))(state);
};

export const authFlowMiddleware = store => next => action => {
  let result = next(action);
  const { getState } = store;
  const {
    auth,
    intl: { locale }
  } = getState();
  locale_messages = messages[locale] || messages["en-GB"];
  handleAction({ state: auth, action, locale_messages });
  return result;
};



// WEBPACK FOOTER //
// ./src/app/auth/middleware.js